module.exports = __webpack_public_path__ + "img/PT-PVEM-MORENA-NABCS.4a579e5f.jpeg";